module.exports = __webpack_public_path__ + "img/ic-info-reload.4e69078f.svg";